import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Tooltip } from "@mui/material";

import { IMessage } from "@/interfaces/message.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

const MUTED_COLOR = "rgba(255, 255, 255, 0.85)";
const READ_COLOR = "#0b3d91";
const FAILED_COLOR = "#d32f2f";

type MessageDeliveryStatusIconProps = {
  chatMessage: Pick<IMessage, "deliveryStatus" | "deliveryError" | "integrationDate">;
  messages: CurrentChatMessages;
};

export default function MessageDeliveryStatusIcon({
  chatMessage,
  messages,
}: MessageDeliveryStatusIconProps) {
  const { deliveryStatus, deliveryError, integrationDate } = chatMessage;
  const iconSx = { fontSize: "1rem", verticalAlign: "middle" };

  const resolve = () => {
    switch (deliveryStatus) {
      case "failed":
        return {
          label: deliveryError
            ? `${messages.deliveryStatusFailed}: ${deliveryError}`
            : messages.deliveryStatusFailed,
          icon: <ErrorOutlineIcon sx={{ ...iconSx, color: FAILED_COLOR }} />,
        };
      case "read":
        return {
          label: messages.deliveryStatusRead,
          icon: <DoneAllIcon sx={{ ...iconSx, color: READ_COLOR }} />,
        };
      case "delivered":
        return {
          label: messages.deliveryStatusDelivered,
          icon: <DoneAllIcon sx={{ ...iconSx, color: MUTED_COLOR }} />,
        };
      case "sent":
        return {
          label: messages.deliveryStatusSent,
          icon: <DoneIcon sx={{ ...iconSx, color: MUTED_COLOR }} />,
        };
      default:
        return integrationDate
          ? {
              label: messages.deliveryStatusSent,
              icon: <DoneIcon sx={{ ...iconSx, color: MUTED_COLOR }} />,
            }
          : {
              label: messages.deliveryStatusPending,
              icon: <AccessTimeIcon sx={{ ...iconSx, color: MUTED_COLOR }} />,
            };
    }
  };

  const { label, icon } = resolve();

  return (
    <Tooltip title={label} placement="left">
      <span
        role="img"
        aria-label={label}
        style={{ display: "inline-flex", alignItems: "center", marginLeft: 4 }}
      >
        {icon}
      </span>
    </Tooltip>
  );
}
